<footer class="page-footer font-small fondoAzulO pt-4">
    <div class="container text-md-left">
        <div class="row p-5">
            <div class="col-md-6 mt-md-0 mt-3">
                {{url}}
                <p>
                    <br><br>
                </p>
                <img width="300px" src="assets/images/general/LOGOMARCA_COMPLETA_MP_GRIS.png">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <img width="20%" src="assets/images/general/logobnpwhite.png">
                <div class="divContenido fontMS300 text-grisC font-18" style="line-height: 130%; color: #8f8c8a;"
                    [innerHTML]="theHtmlString">
                </div>
                <!-- <p class="fontMS700 text-left font-24" style="color: #8f8c8a;">
                    <br><br>
                    FERNANDO GARREAUD Y EL<br>
                    ÁLBUM REPÚBLICA PERUANA 1900:<br>
                    <a class="fontMS100"> LA PERSISTENCIA DE LA MEMORIA</a>
                    <br><br>
                    Curaduría e investigación:<br>
                    <a class="fontMS100">Benjamín Blass Rivarola</a>
                    <br><br>
                    Diseño Gráfico:<br>
                    <a class="fontMS100">Malkiel Moreno Aznaran</a>
                    <br><br>
                </p> -->
            </div>
            <hr class="clearfix w-100 d-md-none pb-3">
            <div class="col-md-3 mb-md-0 mb-3">
            </div>
            <div class="col-md-3 mb-md-0 mt-3 mb-3">
                <p>
                    <br><br>
                </p>
                <p class="font-18">
                    <a href="https://www.facebook.com/BibliotecaNacionalPeru" target="_blank">
                    <mdb-icon fab icon="facebook-f"></mdb-icon>
                    </a>
                    &nbsp;&nbsp;
                    <a href="https://twitter.com/BibliotecaPeru" target="_blank">
                    <mdb-icon fab icon="twitter"></mdb-icon>
                    </a>
                    &nbsp;&nbsp;
                    <a href="https://www.instagram.com/bibliotecaperu/?hl=es-la" target="_blank">
                    <mdb-icon fab icon="instagram"></mdb-icon>
                    </a>
                    &nbsp;&nbsp;
                    <a href="https://www.youtube.com/user/BibliotecaNacionalP" target="_blank">
                    <mdb-icon fab icon="youtube"></mdb-icon>
                    </a>
                    &nbsp;&nbsp;
                    <a href="https://open.spotify.com/user/d468d98e6fg7f6iaxvhc00khh?si=8SnA0wD4QxqjYV5kB7SK-Q&nd=1" target="_blank">
                        <mdb-icon fab icon="spotify"></mdb-icon>
                    </a>
                    &nbsp;&nbsp;
                </p>
            </div>
        </div>
    </div>
</footer>
<footer class="fondoAzulOI">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <p class="text-center text-grisC">
                    <br>
                    Aplicativo Administrado por la Oficina de Tecnologías de la Información y Estadistica - © 2021 Copyright: Biblioteca Nacional del Perú
                </p>
            </div>
        </div>
    </div>
</footer>